import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { isEmpty } from 'lodash';
import classNames from 'classnames/bind';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Divider from '@material-ui/core/Divider';
import FormHelperText from '@material-ui/core/FormHelperText';
import networkingSchema from '../../schemas/networkingSchema';
import styles from './networking.module.scss';

const conditionalStyles = classNames.bind(styles);

export default class Networking extends Component {
    constructor(props) {
        super(props);

        this.form = React.createRef();
    }

    componentDidMount() {
        if (!this.form.current.state.values.AbleToComplete) {
            this.form.current.state.values.AbleToComplete = true;

            this.props.updateStep(this.form.current.state.values);
        } else if (this.props.editable) {
            this.form.current.submitForm();
        }
    }

    componentWillUnmount() {
        if (this.props.editable) {
            this.form.current.state.values.Completed = (this.form.current.state.values.InitialValid)
                ? true
                : isEmpty(this.form.current.state.errors) &&
                !isEmpty(this.form.current.state.touched);

            this.form.current.state.values.InitialValid = false;

            this.props.updateStep(this.form.current.state.values);
        }
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.fieldsContainer}>
                    <Formik
                        ref={this.form}
                        initialValues={{
                            Key: this.props.formData.key,
                            Completed: this.props.formData.Completed,
                            AbleToComplete: this.props.formData.AbleToComplete,
                            InitialValid: this.props.formData.InitialValid,
                            Method: this.props.formData.Method,
                            DNSServer: this.props.formData.DNSServer,
                            LAN: {
                                Method: this.props.formData.LAN.Method,
                                IPAddress: this.props.formData.LAN.IPAddress,
                                Netmask: this.props.formData.LAN.Netmask,
                                Gateway: this.props.formData.LAN.Gateway,
                                Status: this.props.formData.LAN.Status
                            },
                            WAN: {
                                Method: this.props.formData.WAN.Method,
                                IPAddress: this.props.formData.WAN.IPAddress,
                                Netmask: this.props.formData.WAN.Netmask,
                                Gateway: this.props.formData.WAN.Gateway,
                                Status: this.props.formData.WAN.Status
                            },
                            DHCP: {
                                DHCPServer: this.props.formData.DHCP.DHCPServer,
                                IPFrom: this.props.formData.DHCP.IPFrom,
                                IPTo: this.props.formData.DHCP.IPTo,
                                Netmask: this.props.formData.DHCP.Netmask,
                                Gateway: this.props.formData.DHCP.Gateway,
                                DNSServer: this.props.formData.DHCP.DNSServer,
                                TFTP: this.props.formData.DHCP.TFTP
                            }
                        }}
                        enableReinitialize={true}
                        validationSchema={networkingSchema}
                        onSubmit={() => null}
                        render={(props) => (
                            <Form>
                                <div className={styles.row}>
                                    <FormControl
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.Method &&
                                            Boolean(props.errors.Method)
                                        }
                                    >
                                        <InputLabel htmlFor="Method">{this.props.t('common:METHOD')}</InputLabel>
                                        <Select
                                            value={props.values.Method}
                                            onChange={event => {
                                                props.values.WAN.Method = event.target.value === 'Switch'
                                                    ? 'DHCP'
                                                    : props.values.WAN.Method;
                                                props.values.DHCP.DHCPServer = false;
                                                props.touched.WAN = false;
                                                props.touched.DHCP = false;

                                                props.handleChange(event);
                                            }}
                                            onBlur={event => {
                                                props.values.WAN.Method = event.target.value === 'Switch'
                                                    ? 'DHCP'
                                                    : props.values.WAN.Method;
                                                props.values.DHCP.DHCPServer = false;
                                                props.touched.WAN = false;
                                                props.touched.DHCP = false;

                                                props.handleBlur(event);
                                            }}
                                            input={<Input name="Method" id="Method" />}
                                        >
                                            <MenuItem value={'Switch'}>Switch</MenuItem>
                                            <MenuItem value={'Route'}>Route</MenuItem>
                                        </Select>
                                        {
                                            props.touched.Method &&
                                            Boolean(props.errors.Method) &&
                                            <FormHelperText>
                                                {this.props.t(`validations:${props.errors.Method}`)}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                </div>
                                <div className={styles.row}>
                                    <TextField
                                        type="text"
                                        label="DNS"
                                        name="DNSServer"
                                        value={props.values.DNSServer}
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        className={styles.fullField}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.DNSServer &&
                                            Boolean(props.errors.DNSServer)
                                        }
                                        helperText={
                                            (
                                                props.touched.DNSServer &&
                                                Boolean(props.errors.DNSServer)
                                            )
                                                ? <span>{this.props.t('validations:COMMA_SEPARATED_IPS')}</span>
                                                : <span>{this.props.t('validations:COMMA_SEPARATED_IPS')}</span>
                                        }
                                    />
                                </div>
                                <Divider variant="middle" />
                                <div
                                    className={conditionalStyles({
                                        subtitle: true,
                                        inactiveSubtitle: !this.props.editable
                                    })}
                                >
                                    <span>LAN</span>
                                </div>
                                <div className={styles.row}>
                                    <FormControl
                                        className={styles.field}
                                        disabled={!this.props.editable}
                                        error={
                                            props.touched.LAN &&
                                            Boolean(props.errors.LAN) &&
                                            props.touched.LAN.Method &&
                                            Boolean(props.errors.LAN.Method)
                                        }
                                    >
                                        <InputLabel htmlFor="LAN.Method">{this.props.t('common:METHOD')}</InputLabel>
                                        <Select
                                            value={props.values.LAN.Method}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            input={<Input name="LAN.Method" id="LAN.Method" />}
                                            inputProps={{
                                                name: 'LAN.Method',
                                                id: 'LAN.Method',
                                            }}
                                        >
                                            <MenuItem value={'DHCP'}>DHCP</MenuItem>
                                            <MenuItem value={'Static'}>{this.props.t('common:STATIC')}</MenuItem>
                                        </Select>
                                        {
                                            props.touched.LAN &&
                                            Boolean(props.errors.LAN) &&
                                            props.touched.LAN.Method &&
                                            Boolean(props.errors.LAN.Method) &&
                                            <FormHelperText>
                                                {this.props.t(`validations:${props.errors.LAN.Method}`)}
                                            </FormHelperText>
                                        }
                                    </FormControl>
                                    {
                                        props.values.LAN.Method === 'Static' &&
                                        <TextField
                                            type="text"
                                            label="IP"
                                            name="LAN.IPAddress"
                                            value={props.values.LAN.IPAddress}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            className={styles.field}
                                            disabled={!this.props.editable}
                                            error={
                                                props.touched.LAN &&
                                                Boolean(props.errors.LAN) &&
                                                props.touched.LAN.IPAddress &&
                                                Boolean(props.errors.LAN.IPAddress)
                                            }
                                            helperText={
                                                (
                                                    props.touched.LAN &&
                                                    Boolean(props.errors.LAN) &&
                                                    props.touched.LAN.IPAddress &&
                                                    Boolean(props.errors.LAN.IPAddress)
                                                )
                                                    ? <span>{this.props.t(`validations:${props.errors.LAN.IPAddress}`)}</span>
                                                    : ''
                                            }
                                        />
                                    }
                                </div>
                                {
                                    props.values.LAN.Method === 'DHCP' &&
                                    props.values.LAN.Status === '0' &&
                                    <div className={styles.row}>
                                        <span>{this.props.t('wizard:DHCP_LAN_NOT_CONNECTED')}</span>
                                    </div>
                                }
                                {
                                    props.values.LAN.Method === 'Static' &&
                                    <div>
                                        <div className={styles.row}>
                                            <TextField
                                                type="text"
                                                label={this.props.t('common:NETMASK')}
                                                name="LAN.Netmask"
                                                value={props.values.LAN.Netmask}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                className={styles.field}
                                                disabled={!this.props.editable}
                                                error={
                                                    props.touched.LAN &&
                                                    Boolean(props.errors.LAN) &&
                                                    props.touched.LAN.Netmask &&
                                                    Boolean(props.errors.LAN.Netmask)
                                                }
                                                helperText={
                                                    (
                                                        props.touched.LAN &&
                                                        Boolean(props.errors.LAN) &&
                                                        props.touched.LAN.Netmask &&
                                                        Boolean(props.errors.LAN.Netmask)
                                                    )
                                                        ? <span>{this.props.t(`validations:${props.errors.LAN.Netmask}`)}</span>
                                                        : ''
                                                }
                                            />
                                            {
                                                props.values.Method !== 'Route' &&
                                                <TextField
                                                    type="text"
                                                    label="Gateway"
                                                    name="LAN.Gateway"
                                                    value={props.values.LAN.Gateway}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    className={styles.field}
                                                    disabled={!this.props.editable}
                                                    error={
                                                        props.touched.LAN &&
                                                        Boolean(props.errors.LAN) &&
                                                        props.touched.LAN.Gateway &&
                                                        Boolean(props.errors.LAN.Gateway)
                                                    }
                                                    helperText={
                                                        (
                                                            props.touched.LAN &&
                                                            Boolean(props.errors.LAN) &&
                                                            props.touched.LAN.Gateway &&
                                                            Boolean(props.errors.LAN.Gateway)
                                                        )
                                                            ?
                                                            <span>
                                                                {this.props.t(`validations:${props.errors.LAN.Gateway}`)}
                                                            </span>
                                                            : ''
                                                    }
                                                />
                                            }

                                        </div>
                                    </div>
                                }
                                {
                                    props.values.Method === 'Route' &&
                                    <div>
                                        <Divider variant="middle" />
                                        <div className={styles.subtitle}>
                                            <span>WAN</span>
                                        </div>
                                        <div className={styles.row}>
                                            <FormControl
                                                className={styles.field}
                                                disabled={!this.props.editable}
                                                error={
                                                    props.touched.WAN &&
                                                    Boolean(props.errors.WAN) &&
                                                    props.touched.WAN.Method &&
                                                    Boolean(props.errors.WAN.Method)
                                                }
                                            >
                                                <InputLabel htmlFor="WAN.Method">{this.props.t('common:METHOD')}</InputLabel>
                                                <Select
                                                    value={props.values.WAN.Method}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    input={<Input name="WAN.Method" id="WAN.Method" />}
                                                >
                                                    <MenuItem value={'DHCP'}>DHCP</MenuItem>
                                                    <MenuItem value={'Static'}>{this.props.t('common:STATIC')}</MenuItem>
                                                </Select>
                                                {
                                                    props.touched.WAN &&
                                                    Boolean(props.errors.WAN) &&
                                                    props.touched.WAN.Method &&
                                                    Boolean(props.errors.WAN.Method) &&
                                                    <FormHelperText>
                                                        {this.props.t(`validations:${props.errors.WAN.Method}`)}
                                                    </FormHelperText>
                                                }
                                            </FormControl>
                                            {
                                                props.values.WAN.Method === 'Static' &&
                                                <TextField
                                                    type="text"
                                                    label="IP"
                                                    name="WAN.IPAddress"
                                                    value={props.values.WAN.IPAddress}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    className={styles.field}
                                                    disabled={!this.props.editable}
                                                    error={
                                                        props.touched.WAN &&
                                                        Boolean(props.errors.WAN) &&
                                                        props.touched.WAN.IPAddress &&
                                                        Boolean(props.errors.WAN.IPAddress)
                                                    }
                                                    helperText={
                                                        (
                                                            props.touched.WAN &&
                                                            Boolean(props.errors.WAN) &&
                                                            props.touched.WAN.IPAddress &&
                                                            Boolean(props.errors.WAN.IPAddress)
                                                        )
                                                            ?
                                                            <span>
                                                                {this.props.t(`validations:${props.errors.WAN.IPAddress}`)}
                                                            </span>
                                                            : ''
                                                    }
                                                />
                                            }
                                        </div>
                                        {
                                            props.values.WAN.Method === 'DHCP' &&
                                            props.values.WAN.Status === '0' &&
                                            <div className={styles.row}>
                                                <span>{this.props.t('wizard:DHCP_LAN_NOT_CONNECTED')}</span>
                                            </div>
                                        }
                                        {
                                            props.values.WAN.Method === 'Static' &&
                                            <div>
                                                <div className={styles.row}>
                                                    <TextField
                                                        type="text"
                                                        label={this.props.t('common:NETMASK')}
                                                        name="WAN.Netmask"
                                                        value={props.values.WAN.Netmask}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.field}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.WAN &&
                                                            Boolean(props.errors.WAN) &&
                                                            props.touched.WAN.Netmask &&
                                                            Boolean(props.errors.WAN.Netmask)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.WAN &&
                                                                Boolean(props.errors.WAN) &&
                                                                props.touched.WAN.Netmask &&
                                                                Boolean(props.errors.WAN.Netmask)
                                                            )
                                                                ?
                                                                <span>
                                                                    {this.props.t(`validations:${props.errors.WAN.Netmask}`)}
                                                                </span>
                                                                : ''
                                                        }
                                                    />
                                                    <TextField
                                                        type="text"
                                                        label="Gateway"
                                                        name="WAN.Gateway"
                                                        value={props.values.WAN.Gateway}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.field}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.WAN &&
                                                            Boolean(props.errors.WAN) &&
                                                            props.touched.WAN.Gateway &&
                                                            Boolean(props.errors.WAN.Gateway)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.WAN &&
                                                                Boolean(props.errors.WAN) &&
                                                                props.touched.WAN.Gateway &&
                                                                Boolean(props.errors.WAN.Gateway)
                                                            )
                                                                ?
                                                                <span>
                                                                    {this.props.t(`validations:${props.errors.WAN.Gateway}`)}
                                                                </span>
                                                                : ''
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        }
                                        <Divider variant="middle" />
                                        <div className={styles.subtitle}>
                                            <span>{this.props.t('common:DHCP_SERVER')}</span>
                                        </div>
                                        <div className={styles.checkRow}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        checked={props.values.DHCP.DHCPServer}
                                                    />
                                                }
                                                label={this.props.t('common:ENABLED')}
                                                name="DHCP.DHCPServer"
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                className={styles.centeredField}
                                                disabled={!this.props.editable}
                                            />
                                            {
                                                props.values.DHCP.DHCPServer &&
                                                <TextField
                                                    type="text"
                                                    label={this.props.t('common:IP_PROVISIONING')}
                                                    name="DHCP.TFTP"
                                                    value={props.values.DHCP.TFTP}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    className={styles.field}
                                                    disabled={!this.props.editable}
                                                    error={
                                                        props.touched.DHCP &&
                                                        Boolean(props.errors.DHCP) &&
                                                        props.touched.DHCP.TFTP &&
                                                        Boolean(props.errors.DHCP.TFTP)
                                                    }
                                                    helperText={
                                                        (
                                                            props.touched.DHCP &&
                                                            Boolean(props.errors.DHCP) &&
                                                            props.touched.DHCP.TFTP &&
                                                            Boolean(props.errors.DHCP.TFTP)
                                                        )
                                                            ?
                                                            <span>
                                                                {this.props.t(`validations:${props.errors.DHCP.TFTP}`)}
                                                            </span>
                                                            : ''
                                                    }
                                                />
                                            }
                                        </div>
                                        {
                                            props.values.DHCP.DHCPServer &&
                                            <div>
                                                <div className={styles.row}>
                                                    <TextField
                                                        type="text"
                                                        label={this.props.t('common:IP_FROM')}
                                                        name="DHCP.IPFrom"
                                                        value={props.values.DHCP.IPFrom}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.field}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.DHCP &&
                                                            Boolean(props.errors.DHCP) &&
                                                            props.touched.DHCP.IPFrom &&
                                                            Boolean(props.errors.DHCP.IPFrom)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.DHCP &&
                                                                Boolean(props.errors.DHCP) &&
                                                                props.touched.DHCP.IPFrom &&
                                                                Boolean(props.errors.DHCP.IPFrom)
                                                            )
                                                                ?
                                                                <span>
                                                                    {this.props.t(`validations:${props.errors.DHCP.IPFrom}`)}
                                                                </span>
                                                                : ''
                                                        }
                                                    />
                                                    <TextField
                                                        type="text"
                                                        label={this.props.t('common:IP_TO')}
                                                        name="DHCP.IPTo"
                                                        value={props.values.DHCP.IPTo}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.field}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.DHCP &&
                                                            Boolean(props.errors.DHCP) &&
                                                            props.touched.DHCP.IPTo &&
                                                            Boolean(props.errors.DHCP.IPTo)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.DHCP &&
                                                                Boolean(props.errors.DHCP) &&
                                                                props.touched.DHCP.IPTo &&
                                                                Boolean(props.errors.DHCP.IPTo)
                                                            )
                                                                ?
                                                                <span>
                                                                    {this.props.t(`validations:${props.errors.DHCP.IPTo}`)}
                                                                </span>
                                                                : ''
                                                        }
                                                    />
                                                </div>
                                                <div className={styles.row}>
                                                    <TextField
                                                        type="text"
                                                        label={this.props.t('common:NETMASK')}
                                                        name="DHCP.Netmask"
                                                        value={props.values.DHCP.Netmask}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.field}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.DHCP &&
                                                            Boolean(props.errors.DHCP) &&
                                                            props.touched.DHCP.Netmask &&
                                                            Boolean(props.errors.DHCP.Netmask)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.DHCP &&
                                                                Boolean(props.errors.DHCP) &&
                                                                props.touched.DHCP.Netmask &&
                                                                Boolean(props.errors.DHCP.Netmask)
                                                            )
                                                                ?
                                                                <span>
                                                                    {this.props.t(`validations:${props.errors.DHCP.Netmask}`)}
                                                                </span>
                                                                : ''
                                                        }
                                                    />
                                                    <TextField
                                                        type="text"
                                                        label="Gateway"
                                                        name="DHCP.Gateway"
                                                        value={props.values.DHCP.Gateway}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.field}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.DHCP &&
                                                            Boolean(props.errors.DHCP) &&
                                                            props.touched.DHCP.Gateway &&
                                                            Boolean(props.errors.DHCP.Gateway)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.DHCP &&
                                                                Boolean(props.errors.DHCP) &&
                                                                props.touched.DHCP.Gateway &&
                                                                Boolean(props.errors.DHCP.Gateway)
                                                            )
                                                                ?
                                                                <span>
                                                                    {this.props.t(`validations:${props.errors.DHCP.Gateway}`)}
                                                                </span>
                                                                : ''
                                                        }
                                                    />
                                                </div>
                                                <div className={styles.row}>
                                                    <TextField
                                                        type="text"
                                                        label="DNS"
                                                        name="DHCP.DNSServer"
                                                        value={props.values.DHCP.DNSServer}
                                                        onChange={props.handleChange}
                                                        onBlur={props.handleBlur}
                                                        className={styles.fullField}
                                                        disabled={!this.props.editable}
                                                        error={
                                                            props.touched.DHCP &&
                                                            Boolean(props.errors.DHCP) &&
                                                            props.touched.DHCP.DNSServer &&
                                                            Boolean(props.errors.DHCP.DNSServer)
                                                        }
                                                        helperText={
                                                            (
                                                                props.touched.DHCP &&
                                                                Boolean(props.errors.DHCP) &&
                                                                props.touched.DHCP.DNSServer &&
                                                                Boolean(props.errors.DHCP.DNSServer)
                                                            )
                                                                ? <span>{this.props.t('validations:COMMA_SEPARATED_IPS')}</span>
                                                                : <span>{this.props.t('validations:COMMA_SEPARATED_IPS')}</span>
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </Form>
                        )}
                    />
                </div>
            </div>
        );
    }
}
